// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".more-ways-business.mt-144[data-v-341e3f60]{margin-top:0;background:rgba(188,190,192,.2);padding-bottom:89px}@media (max-width:1365px){.more-ways-business.mt-144[data-v-341e3f60]{padding-bottom:55px}}", ""]);
// Exports
module.exports = exports;
